var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import GamesSwiper from "../GamesSwiper/GamesSwiper";
import { CardTitle } from "../styles";
import { connect } from "react-redux";
function GamesLobbyItems(_a) {
    var getMore = _a.getMore, title = _a.title, lobbyGames = _a.games, darkTheme = _a.darkTheme;
    if (!lobbyGames || !lobbyGames.length)
        return null;
    return (_jsx("div", { children: _jsxs("div", { children: [_jsxs(CardTitle, __assign({ style: {
                        border: darkTheme && "none",
                        backgroundColor: darkTheme && "#585858",
                        color: darkTheme && "#fff",
                    }, onClick: getMore }, { children: [_jsx("span", { children: title }), _jsx("div", { className: "arrow-right ".concat(darkTheme ? "dark" : "") })] })), _jsx(GamesSwiper, { games: lobbyGames, getMore: getMore })] }) }));
}
export default connect(function (state) { return ({
    langId: state.application.get("languageId"),
    darkTheme: state.application.get("darkTheme"),
}); })(GamesLobbyItems);



// WEBPACK FOOTER //
// ./src/components/games/components/GamesLobbyItems/GamesLobbyItems.jsx